import Form from './src/form.vue';
import FormItem from './src/form-item.vue';
import { SFCWithInstall, withInstall } from '@touchvue/utils';

export const ToForm: SFCWithInstall<typeof Form> = withInstall(Form);
export const ToFormItem: SFCWithInstall<typeof FormItem> = withInstall(FormItem);

export * from './src/instance';
